import React from 'react'
import t from 'prop-types'

import { 
    Util, 
    Flashcards, 
    Boton, 
    BotonImagen, 
    Precarga, 
    VentanaImpresion 
} from 'ibook-api'

const sessionStorageKey = 'pantalla-seleccionar-flashcards-last-state'
class Pantalla extends React.Component {
    static propTypes = {
        // plantillaId: t.string.isRequired,
        zonaFC: t.string.isRequired,
        zonaTips: t.string,

        minFC: t.number.isRequired, // num minimo de fc que hay que seleccionar

        titulo: t.string.isRequired,
        textoPasoPrevio: t.string.isRequired,
        textoSeleccionarImagenes: t.string.isRequired, // Select images
        textoSeleccionarTodo: t.string.isRequired, // Select All
        textoSeleccionarNada: t.string.isRequired, // Clear Selection
        textoEliminarSeleccionados: t.string.isRequired, // Delete Selection
        textoAgregar: t.string.isRequired, // Agregar
        textoContinuar: t.string.isRequired,
        textoAtras: t.string.isRequired,
        textoPlaceHolderTemas: t.string.isRequired,
        textoAviso: t.arrayOf(t.string), // elemento 0 => singular, elemento 1 => plural, # marcador de posicion para variable minFC
        textoImprimir: t.string.isRequired,
        textoImagenesSeleccionadas: t.string.isRequired,
        textoTips: t.string.isRequired,
        textoImagenes: t.string.isRequired,
        textoImagenesMasPalabras: t.string.isRequired,

        fondoCabecera: t.string.isRequired,
        logo: t.string, 

        visualizacionComboUnidades: t.string,
        modoVisualizacionComboUnidades: t.string,
        visualizacionBotonesLetras: t.string,
        visualizacionBotonesUnidades: t.string,

        onContinuar: t.func.isRequired,
        onAtras: t.func.isRequired,
        onVolverAMenu: t.func.isRequired,
        onTip: t.func.isRequired,
        onImprimir: t.func.isRequired,

        nivel: t.string.isRequired
    }

    constructor(props) {
        super(props)

        const lastState = JSON.parse(Util.sessionStorage.getItem(sessionStorageKey) || "{}")

        this.state = {
            temas: null,
            orden: null,

            datos: [],
            datosSeleccionados: [],

            fcs: [],
            fcsSeleccionados: [],

            ventanaImpresionAbierta: false,

            ...lastState
        }
    }

    handleChangeDatos = (datos) => {
        const datosSeleccionados = datos.map( () => false )
        this.setState({datos, datosSeleccionados })
    }

    handleSeleccionarDato = (index) => {
        const datosSeleccionados = [...this.state.datosSeleccionados]
        datosSeleccionados[index] = !datosSeleccionados[index]
        this.setState({datosSeleccionados})
    }

    handleSeleccionarFc = (index) => {
        const fcsSeleccionados = [...this.state.fcsSeleccionados]
        fcsSeleccionados[index] = !fcsSeleccionados[index]
        this.setState({fcsSeleccionados})
    }

    handleAgregarSeleccionadas = () => {
        // const { onFlashcardsSeleccionadas } = this.props
        const { datos, datosSeleccionados } = this.state
        
        const fcsSet = new Set(this.state.fcs)
        datosSeleccionados.forEach( (seleccionada, index) => seleccionada && fcsSet.add(datos[index]) )
        
        const fcs = Array.from(fcsSet)
        this.setState({
            fcs,
            fcsSeleccionados: fcs.map(() => false),
            datosSeleccionados: datosSeleccionados.map( () => false )
        }) //, () => onFlashcardsSeleccionadas( this.state.fcs ) )
    }

    handleSeleccionarTodoDatos = () => {
        this.setState({
            datosSeleccionados: this.state.datosSeleccionados.map( () => true )
        })
    }

    handleSeleccionarNadaDatos = () => {
        this.setState({
            datosSeleccionados: this.state.datosSeleccionados.map( () => false )
        })
    }

    handleSeleccionarNadaFcs = () => {
        this.setState({
            fcsSeleccionados: this.state.fcsSeleccionados.map( () => false )
        })
    }

    handleSeleccionarTodoFcs = () => {
        const { fcsSeleccionados } = this.state
        this.setState({
            fcsSeleccionados: fcsSeleccionados.map( () => true )
        })
    }

    handleEliminarSeleccionFcs = () => {
        //const { onFlashcardsSeleccionadas } = this.props
        const { fcs, fcsSeleccionados } = this.state
        const fcsRestantes = fcs.filter( (fcs, index) => !fcsSeleccionados[index] )
        this.setState({
            fcs: fcsRestantes,
            fcsSeleccionados: fcsRestantes.map( () => false )
        }) //, () => onFlashcardsSeleccionadas( this.state.fcs ))
    }

    handleContinuar = () => {
        Util.sessionStorage.setItem(sessionStorageKey, JSON.stringify(this.state) )

        const { zonaFC, onContinuar } = this.props
        const { fcs } = this.state
        const { libroId, numPagina, numZona } = Util.decodificarZonaId(zonaFC)
        onContinuar(libroId, numPagina, numZona, fcs)
    }

    handleTip = () => {
        const { zonaTips, onTip } = this.props
        const { libroId, numPagina, numZona } = Util.decodificarZonaId(zonaTips)
        onTip(libroId, numPagina, numZona)
    }

    handleAbrirVentanaImpresion = () => this.setState({ ventanaImpresionAbierta: true })    
    handleCerrarVentanaImpresion = () => this.setState({ ventanaImpresionAbierta: false })

    handleVolverAMenu = () => this.props.onVolverAMenu()

    handleSubirSeleccionFcs = () => {
        const { fcs, fcsSeleccionados } = this.state
        fcs.forEach( (value, index) => {
            if (index < fcs.length - 1 && !fcsSeleccionados[index]) {
                if (fcsSeleccionados[index + 1]) {
                    fcs[index] = fcs[index + 1]
                    fcs[index + 1] = value                    
                    fcsSeleccionados[index] = true
                    fcsSeleccionados[index + 1] = false
                } 
            }
        })
        this.setState({ fcs, fcsSeleccionados })
    }

    handleBajarSeleccionFcs = () => {
        const { fcs, fcsSeleccionados } = this.state
        for (let index = fcs.length - 1; index > 0; index--) {
            const value = fcs[index]
            if (!fcsSeleccionados[index]) {
                if (fcsSeleccionados[index - 1]) {
                    fcs[index] = fcs[index - 1]
                    fcs[index - 1] = value
                    fcsSeleccionados[index] = true
                    fcsSeleccionados[index - 1] = false
                }
            }
        }
        this.setState({ fcs, fcsSeleccionados })
    }

    componentDidMount() {
        const { temas, orden } = this.state
        if (temas && orden) {
            return
        }        

        Util.fetch('contenido/FCs/flashcards/grp.json')
            .then(response => response.json())
            .then(json => {
                const { TEMAS: temas, ORDEN: orden } = json.data
                this.setState({ temas, orden })
            })
    }

    getNumDatosSeleccionados = () => {
        const { datosSeleccionados } = this.state
        return datosSeleccionados.reduce( (previousValue, currentValue) => { 
                return currentValue ? previousValue + 1 : previousValue 
            }, 0
        )
    }

    getNumFcsSeleccionados = () => {
        const { fcsSeleccionados } = this.state
        return fcsSeleccionados.reduce( (previousValue, currentValue) => { 
                return currentValue ? previousValue + 1 : previousValue 
            }, 0
        )
    }

    renderAviso() {        
        const { textoAviso, minFC } = this.props
        const { fcsSeleccionados } = this.state
        if (fcsSeleccionados.length >= minFC ) {
            return null
        }

        const aviso = minFC > 1 ? textoAviso[1] : textoAviso[0]
        return <div className="cajaAvisosSelectorImagenes"><span>{ aviso.split('#').join(minFC) }</span></div>
    }

    render() {
        const { minFC, titulo, logo, fondoCabecera,
            visualizacionComboUnidades, modoVisualizacionComboUnidades, visualizacionBotonesLetras, visualizacionBotonesUnidades,
            textoSeleccionarImagenes, textoImagenesSeleccionadas, textoPlaceHolderTemas,
			textoSeleccionarTodo, textoSeleccionarNada,
            textoEliminarSeleccionados, textoUsarSeleccionados, textoSubirSeleccionados, textoBajarSeleccionados,
            textoAgregar, textoAtras, textoImprimir, 
            botonesContenedor_nexoCajasMiniaturas, botonesContenedor_controlesSeleccion, botonesContenedor_botoneraInferiorSelector, botonesContenedor_botoneraCajaMiniaturas,
            textoTips,
            textoImagenes, textoImagenesMasPalabras, nivel, onImprimir, adornos } = this.props 

        const { temas, orden, datos, datosSeleccionados, fcs, fcsSeleccionados, ventanaImpresionAbierta } = this.state
        const numDatosSeleccionados = this.getNumDatosSeleccionados()
        const numFcsSeleccionados = this.getNumFcsSeleccionados()

        const renderBotonPasoMiniaturas = <BotonImagen clases='botonPasoMiniaturas' desactivado={ numDatosSeleccionados === 0 } onClick={ this.handleAgregarSeleccionadas }>{ textoAgregar }</BotonImagen>
        const renderCajaAvisosSelectorImagenes = this.renderAviso ()
        const renderBotonSubirSeleccion = <BotonImagen clases='botonSubirSeleccion' desactivado={ numFcsSeleccionados === 0 } onClick={ this.handleSubirSeleccionFcs } >{ textoSubirSeleccionados }</BotonImagen>
        const renderBotonBajarSeleccion = <BotonImagen clases='botonBajarSeleccion' desactivado={ numFcsSeleccionados === 0 } onClick={ this.handleBajarSeleccionFcs } >{ textoBajarSeleccionados }</BotonImagen>
        const renderBotonEliminarSeleccion = <BotonImagen clases='botonEliminarSeleccion' desactivado={ numFcsSeleccionados === 0 } onClick={ this.handleEliminarSeleccionFcs } >{ textoEliminarSeleccionados }</BotonImagen>
        const renderBotonUsarSeleccion = <BotonImagen clases='botonUsarSeleccion' desactivado={ fcsSeleccionados.length < minFC } onClick={ this.handleContinuar } >{ textoUsarSeleccionados }</BotonImagen>
        const renderBotonImprimir = <Boton clases='botonImprimir' desactivado={ fcs.length === 0 } onClick={ this.handleAbrirVentanaImpresion }>{ textoImprimir }</Boton>
        const renderVolverAMenu = <BotonImagen clases='volverAMenu' onClick={ this.handleVolverAMenu }>{ textoAtras }</BotonImagen>
        const renderBotonSeleccionarTodo = <Flashcards.BotonCajaMiniaturas desactivado={ fcs.length === 0 || fcs.length === numFcsSeleccionados } onClick={ this.handleSeleccionarTodoFcs } >{ textoSeleccionarTodo }</Flashcards.BotonCajaMiniaturas>
        const renderBotonDeseleccionarTodo = <Flashcards.BotonCajaMiniaturas desactivado={ numFcsSeleccionados === 0 } onClick={ this.handleSeleccionarNadaFcs } >{ textoSeleccionarNada }</Flashcards.BotonCajaMiniaturas>

        const fcsParaImprimir = (nivel !== "faltaDefinir") 
            ? fcs
            : fcs.map( fc => { const num = fc.substr(1); return `1${num},2${num},3${num}` }).join(',').split(',')

        if (temas === null || orden === null) {
            return <div className="fondoMenus">
                <div className="selectorImagenes flashcards">
                    <Precarga />
                </div>
            </div>
        }

        return (
            <div className="fondoMenus">
                <div className="selectorImagenes flashcards">
                    { adornos && 
                        adornos.map( 
                            num => <img 
                                alt="" 
                                key={`adorno-${num}`} 
                                className={`adorno${num}`} 
                                src={`css/imagenes/menus/adorno${num}.png`} 
                            /> 
                        )
                    }
                    <div className="cabeceraSelector">
                        { fondoCabecera && <img src={ fondoCabecera } alt="" /> }	
                        { logo !== false && <div className="logo"></div> }			        
                        <div className="titulo" dangerouslySetInnerHTML={{ __html: titulo }} />
                        <BotonImagen clases='botonIndicaciones' onClick={ this.handleTip }>{ textoTips }</BotonImagen>
                    </div>
                    <div className="columnaSeleccion">
                        { visualizacionComboUnidades && modoVisualizacionComboUnidades!=='div' && <Flashcards.Temas modoCombo={ true } titulo="" placeHolder={ textoPlaceHolderTemas } temas={ temas } datos={ datos } onDatos={ this.handleChangeDatos } /> }
                        { visualizacionComboUnidades && modoVisualizacionComboUnidades==='div' && <Flashcards.Temas modoCombo={ false } titulo="" placeHolder={ textoPlaceHolderTemas } temas={ temas } datos={ datos } onDatos={ this.handleChangeDatos } /> }
                        { visualizacionBotonesLetras && <Flashcards.Letras orden={ orden } onDatos={ this.handleChangeDatos } /> }
                        <div className="seleccionSuperior">                        
                            <div className="cabeceraCajaMiniaturas">
                                { textoSeleccionarImagenes }
                                { visualizacionBotonesUnidades && <Flashcards.Unidades unidades={ temas } datos={ datos } onDatos={ this.handleChangeDatos } /> }
                                </div>
                            <Flashcards.CajaMiniaturas 
                                flashcards={ datos } 
                                seleccionadas={ datosSeleccionados } 
                                onSeleccionar={ this.handleSeleccionarDato }
                            />
                            <div className="botoneraCajaMiniaturas">
                                <Flashcards.BotonCajaMiniaturas desactivado={ datos.length === 0 || datos.length === numDatosSeleccionados } onClick={ this.handleSeleccionarTodoDatos } >{ textoSeleccionarTodo }</Flashcards.BotonCajaMiniaturas>
                                <Flashcards.BotonCajaMiniaturas desactivado={ numDatosSeleccionados === 0 } onClick={ this.handleSeleccionarNadaDatos } >{ textoSeleccionarNada }</Flashcards.BotonCajaMiniaturas>
                            </div>
                        </div>
                        <div className="nexoCajasMiniaturas">
                            { botonesContenedor_nexoCajasMiniaturas && botonesContenedor_nexoCajasMiniaturas.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                            { !botonesContenedor_nexoCajasMiniaturas && renderBotonPasoMiniaturas }
                            { !botonesContenedor_nexoCajasMiniaturas && renderCajaAvisosSelectorImagenes }
                        </div>
                        <div className="seleccionInferior">
                            <div className="cabeceraCajaMiniaturas">{ textoImagenesSeleccionadas }</div>
                            <Flashcards.CajaMiniaturas
                                flashcards={ fcs } 
                                seleccionadas={ fcsSeleccionados } 
                                onSeleccionar={ this.handleSeleccionarFc } 
                            />
                            <div className="botoneraCajaMiniaturas">
                                { botonesContenedor_botoneraCajaMiniaturas && botonesContenedor_botoneraCajaMiniaturas.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                                { !botonesContenedor_botoneraCajaMiniaturas && renderBotonSeleccionarTodo }
                                { !botonesContenedor_botoneraCajaMiniaturas && renderBotonDeseleccionarTodo }
                            </div>
                        </div>                    
                        <div className="controlesSeleccion">
                            { botonesContenedor_controlesSeleccion && botonesContenedor_controlesSeleccion.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                            { !botonesContenedor_controlesSeleccion && renderBotonSubirSeleccion }
                            { !botonesContenedor_controlesSeleccion && renderBotonBajarSeleccion }
                            { !botonesContenedor_controlesSeleccion && renderBotonEliminarSeleccion }
                            { !botonesContenedor_controlesSeleccion && renderBotonUsarSeleccion }
                        </div>
                    </div>
                    <div className="botoneraInferiorSelector">
                        { botonesContenedor_botoneraInferiorSelector && botonesContenedor_botoneraInferiorSelector.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                        { !botonesContenedor_botoneraInferiorSelector && renderBotonImprimir }
                        { !botonesContenedor_botoneraInferiorSelector && renderVolverAMenu }
                    </div>
                </div>
                { ventanaImpresionAbierta && 
                    <VentanaImpresion 
                        abierta={ ventanaImpresionAbierta } 
                        fcs={ fcsParaImprimir }
                        
                        textoImprimir={ textoImprimir }
                        textoImagenes={ textoImagenes }
                        textoImagenesMasPalabras={ textoImagenesMasPalabras }

                        onCerrar={ this.handleCerrarVentanaImpresion }
                        onImprimir={ onImprimir }
                    />
                }
            </div>
        )
    }
}

export default Pantalla